var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c("div", {}, [
        _vm.loading
          ? _c(
              "span",
              { staticClass: "loading" },
              [
                _c("ClipLoader", {
                  attrs: { color: "#2e3f50", loading: _vm.loading, size: 20 },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "edit-section" }, [
          _c("a", { on: { click: _vm.editStudentTracks } }, [_vm._v("ערוך")]),
        ]),
        _vm.tracksStudentModel && _vm.tracksStudentModel.length
          ? _c(
              "div",
              { staticClass: "StudentGroups__Container" },
              _vm._l(_vm.tracksStudentModel, function (track) {
                return _c(
                  "div",
                  {
                    key: track.id,
                    staticClass: "StudentGroupsWidget__Component",
                    class: [track.isSelected && "green"],
                  },
                  [
                    _c("p", [
                      _vm._v(
                        _vm._s(track.trackName) +
                          " בקורס: " +
                          _vm._s(track.courseName)
                      ),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        !_vm.loading && !_vm.tracksStudentModel.length
          ? _c("div", [_vm._v("אין הרצאות משויכות למשתמש")])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }